import { createApiRef } from "@backstage/core-plugin-api";
import { PolicyCenterClient } from "@internal/backstage-plugin-policy-center-common";

/**
 * ApiRef for the Policy Center plugin.
 */
export const policyCenterApiRef = createApiRef<PolicyCenterClient>({
    id: "plugin.policy-center.service",
});
